import type {
  BreedSize,
  FoodType,
  LifeStage,
  PetType,
  ProductLine,
  SpecialNeed,
} from '@/types/catalog';

import { COMMERCE } from '@/config/site';

export const SORT_OPTIONS = [
  { value: 'relevance', label: 'Mais relevantes', revealsPrice: false },
  { value: 'price-asc', label: 'Menor preço', revealsPrice: true },
  { value: 'price-desc', label: 'Maior preço', revealsPrice: true },
  { value: 'price-per-kg', label: 'Melhor preço por kg', revealsPrice: true },
  { value: 'rating', label: 'Melhor avaliados', revealsPrice: false },
  { value: 'name', label: 'Nome (A–Z)', revealsPrice: false },
] as const;

export type SortValue = (typeof SORT_OPTIONS)[number]['value'];

/**
 * Opções realmente oferecidas ao visitante.
 *
 * Ordenar por preço expõe a ordenação completa do catálogo, então as opções de
 * preço saem do menu quando `showPrices` está desligado.
 */
export const VISIBLE_SORT_OPTIONS = SORT_OPTIONS.filter(
  (option) => COMMERCE.showPrices || !option.revealsPrice,
);

/** Every filter maps 1:1 to a URL search param, so views are shareable. */
export interface CatalogFilters {
  search: string;
  pet: PetType[];
  brand: string[];
  stage: LifeStage[];
  size: BreedSize[];
  line: ProductLine[];
  type: FoodType[];
  need: SpecialNeed[];
  /** `null` means "no ceiling set" — the slider sits at max. */
  maxPrice: number | null;
  onlyInStock: boolean;
  onlyOnSale: boolean;
  sort: SortValue;
}

export const EMPTY_FILTERS: CatalogFilters = {
  search: '',
  pet: [],
  brand: [],
  stage: [],
  size: [],
  line: [],
  type: [],
  need: [],
  maxPrice: null,
  onlyInStock: false,
  onlyOnSale: false,
  sort: 'relevance',
};

/** Multi-value filter keys — the ones rendered as checkbox groups. */
export const MULTI_KEYS = ['pet', 'brand', 'stage', 'size', 'line', 'type', 'need'] as const;

export type MultiKey = (typeof MULTI_KEYS)[number];
